import type { GetStartedService } from "~/components/get-started/types";
import { useServiceListType } from "~/composables/globalConfig";

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.params.section !== "sexual-health" || !to.params.service) {
    return;
  }

  const { data: servicesResult } = await useServiceListType();
  const services = servicesResult.value?.data ?? [];
  const serviceExists = services.some(
    (service: GetStartedService) => service.slug === to.params.service,
  );

  if (!serviceExists) {
    throw createError({
      statusCode: 404,
      statusMessage: "Page Not Found",
      fatal: true,
    });
  }
});
